import React, { useState, useEffect } from 'react';
import { Outlet } from 'react-router-dom';
import { Box, useMediaQuery, useTheme } from '@mui/material';
import AppBar from './AppBar';
import Sidebar from './Sidebar';

const MainLayout = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  const [sidebarOpen, setSidebarOpen] = useState(() => {
    const saved = localStorage.getItem('beworks_sidebar_open');
    return saved !== null ? JSON.parse(saved) : !isMobile;
  });

  const [sidebarPinned, setSidebarPinned] = useState(() => {
    const saved = localStorage.getItem('beworks_sidebar_pinned');
    return saved !== null ? JSON.parse(saved) : true;
  });

  useEffect(() => {
    if (isMobile) {
      setSidebarOpen(false);
    } else if (sidebarPinned) {
      setSidebarOpen(true);
    }
  }, [isMobile, sidebarPinned]);

  const handleToggleSidebar = () => {
    const newState = !sidebarOpen;
    setSidebarOpen(newState);
    if (!isMobile) {
      localStorage.setItem('beworks_sidebar_open', JSON.stringify(newState));
    }
  };

  const handleCloseSidebar = () => {
    if (isMobile) {
      setSidebarOpen(false);
    }
  };

  const handleTogglePin = () => {
    const newState = !sidebarPinned;
    setSidebarPinned(newState);
    localStorage.setItem('beworks_sidebar_pinned', JSON.stringify(newState));

    if (!newState) {
      setSidebarOpen(false);
    } else {
      setSidebarOpen(true);
    }
  };

  const handleMouseEnter = () => {
    if (!isMobile && !sidebarPinned && !sidebarOpen) {
      setSidebarOpen(true);
    }
  };

  const handleMouseLeave = () => {
    if (!isMobile && !sidebarPinned && sidebarOpen) {
      setSidebarOpen(false);
    }
  };

  return (
    <Box sx={{ display: 'flex', minHeight: '100vh' }}>
      <AppBar
        open={sidebarOpen}
        onToggleSidebar={handleToggleSidebar}
      />

      <Box
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
      >
        <Sidebar
          open={sidebarOpen}
          onClose={handleCloseSidebar}
          isPinned={sidebarPinned}
          onTogglePin={handleTogglePin}
          isMobile={isMobile}
        />
      </Box>

      <Box
        component="main"
        sx={{
          flexGrow: 1,
          p: 3,
          mt: 8,
          backgroundColor: 'background.paper',
          minHeight: '100vh',
        }}
      >
        <Outlet />
      </Box>
    </Box>
  );
};

export default MainLayout;
